var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAx = function SvgAx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M23.587 15.13c.269-.998.413-2.047.413-3.13 0-1.084-.144-2.133-.413-3.131L10.957.045A11.939 11.939 0 0 0 4.696 2.48L.413 8.869A12.013 12.013 0 0 0 0 11.999c0 1.077.143 2.12.409 3.114l4.287 6.407a11.938 11.938 0 0 0 6.26 2.434l12.63-8.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M.413 15.13a12.01 12.01 0 0 0 4.282 6.39v-6.39H.413ZM10.956 23.954c.344.03.692.046 1.043.046 5.545 0 10.21-3.76 11.587-8.87h-12.63v8.824ZM23.586 8.87C22.21 3.76 17.544 0 12 0c-.352 0-.7.016-1.044.046V8.87h12.63ZM4.695 2.48A12.01 12.01 0 0 0 .413 8.87h4.282V2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.898 10.434H9.391V.284C8.282.532 7.231.93 6.261 1.46v8.975H.1a12.104 12.104 0 0 0 0 3.13h6.16v8.976c.97.53 2.021.928 3.13 1.174v-10.15h14.507a12.118 12.118 0 0 0 0-3.13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAx;